import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import Loader from './../shared/loader'
import router from '../../../router'
export default {
	name: 'Packing',
	components: {
		Loader,
	},
	data: function() {
		return {
			type: '',
			packingtypebin: '',
			packingtypetote: '',
			isfound: false,
			isnotfound: false,
			loadingText: '<i class="fa fa-spinner fa-spin fa-2x" style="color:#1985ac"></i>',
			rightIcon: '<i class="fa fa-check" style="font-size:25px;color:green" v-if="isfoundID"></i>',
			wrongIcon: '<i class="fa fa-close" style="font-size:25px;color:red" v-if="isnotfoundID"></i>',
			clientid: '',
			client: '',
			isError: '',
			loading: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			listWarehouseData: [],
			listClientData: [],
			isLoading: false,
			productsPendingData: [],
			isfoundDataPendingProduct: false,
			boxId: '',
			orderId: '',
			userId: '',
			boxMapped: false,
			productId: '',
			showQCButton: false,
			uniqueIdScanProduct: '',
			rejectCheck: false,
			isOtherReason: false,
			checkedNames: [],
			otherreason: '',
			isCheckboxError: '',
			rejectreasons: [],
			productDetails: [],
			awbNo: '',
			courierName: '',
			salesChannel: [],
			showOrder: false,
			showBoxId: false,
			showPackingComplete: false,
			shipmentFound: false,
			allocationId: '',
			minisocheck: false,
			clientName: "",
			totalquantity: 0,
			cancel: 0,
			canceldetails: [],
			shipmentPrintNotAvailable: false,
			shipmentPrintNotAvailableMSG: '',
			clientidForPrint: '',
			warehouseidForPrint: '',
			orderidForPrint: '',
			shippingcompanyForPrint: '',
			awbnoForPrint: '',
			totalsku: 0,
			qcacceptqty: 0,
			qcrejectqty: 0,
			boxdetails: [],
			orderDetails: {},
			boxl: '',
			boxb: '',
			boxh: '',
			seller: '',
			boxStatus: '',
			orderStatus: '',
			shipmentStatus: '',
			couriername: '',
			showboxdetails: false,
			showOrderDetails: false,
			productCheckIcon: '',
			boxweight: 0,
			client: '',
			btnDisable: false,
			printInvoiceEnable: false,
			printLabelEnable: false,
			isfoundproductId: false,
			isnotfoundproductId: false,
			showBox: false,
			boxIdMapped: false,
		}
	},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.user_type = userdetail.utype;
		this.useremail = userdetail.email;
		this.userId = userdetail.userid;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.showSelectWarehouse = true;
				this.showSelectClient = false;
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.showSelectClient = true;
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		validateData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					console.log(result, "valid form");
					this.checkAwb()
				} else {
					console.log(result, "invalid form");
					return false
				}
			}).catch((error) => {
				console.log(error, "error");
				this.errorReport(error);
			});
		},
		PrintLabelAgaintsClient() {
			if (this.shipmentPrintNotAvailable) {
				this.printLabel();
			} else {
				this.printConfigLabel();
			}
		},

		printConfigLabel() {
			if (this.clientidForPrint == '') {
				this.$alertify.error(this.$t('common.invalidClientErr'));
				return false;
			}
			if (this.warehouseidForPrint == '') {
				this.$alertify.error(this.$t('common.invalidWarehouseErr'));
				return false;
			}
			if (this.awbnoForPrint.trim() == '') {
				this.$alertify.error(this.$t('common.invalidAWBNoErr'));
				return false;
			}
			if (this.orderidForPrint.trim() == '') {
				this.$alertify.error(this.$t('common.invalidOrderIdErr'));
				return false;
			}
			if (this.shippingcompanyForPrint.trim() == '') {
				this.$alertify.error(this.$t('common.invalidShippingErr'));
				return false;
			}
			let routeData = ''
			routeData = this.$router.resolve({
				name: 'shippinglabel',
				params: {
					"clientid": Number(this.clientidForPrint),
					"warehouseid": this.warehouseidForPrint,
					"awbno": this.awbnoForPrint,
					"orderid": this.orderidForPrint,
					"shippingcompany": this.shippingcompanyForPrint,
				},
				query: {
					clientid: Number(this.clientidForPrint),
					warehouseid: this.warehouseidForPrint,
					awbno: this.awbnoForPrint,
					orderid: this.orderidForPrint,
					shippingcompany: this.shippingcompanyForPrint,
				},
			});
			window.open(routeData.href, '_blank');
		},

		printLabel() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "getboxclient",
					data: ({
						warehouseid: userdetail.warehouseid,
						boxid: this.boxId,
					}),
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((clientdata) => {
					this.client = clientdata.data.data[0].data.clientid;
					if (clientdata.data.data[0].ErrorCode == -1) {
						this.productCheckIcon = '';
						this.$alertify.error(clientdata.data.data[0].msg);
					} else if (clientdata.data.data[0].ErrorCode == 0) {
						var clientid = clientdata.data.data[0].data[0].clientid;
						this.input = ({
							clientid: clientid,
							boxid: this.boxId,
						});
						this.isLoading = true
						axios({
								method: "post",
								url: apiUrl.api_url + "getPrintUrl",
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								},
							})
							.then((response) => {
								if (response.data.ErrorCode == 0) {
									if (response.data.data.shipping_label_document_external_url) {
										window.open(response.data.data.shipping_label_document_external_url, "_blank");
									} else {
										this.$alertify.error(this.$t('common.labelURLErr'));
									}
								} else {
									this.$alertify.error(result.data.msg);
								}
								this.isLoading = false
							})
							.catch((error) => {
								this.errorReport(error);
							});
					}
					this.isLoading = false
				}).catch((error) => {
					this.errorReport(error);
				});
			return false
		},

		PrintInvoiceAgaintsClient() {
			if (this.shipmentPrintNotAvailable) {
				this.printInvoice();
			} else {
				this.btnDisable = true
				this.printConfigprintInvoice();
			}
		},

		printConfigprintInvoice() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var input = ({
				clientid: this.clientidForPrint,
				warehouseid: this.warehouseidForPrint,
				awbno: this.awbnoForPrint,
				orderid: this.orderidForPrint,
				shippingcompany: this.shippingcompanyForPrint,
			})
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "getinvoicedata",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((response) => {
					if (response.status) {
						//var a = response.data.printData.invoiceData.replace("/n", "")
						var a = response.data.printData.invoiceData
						var myWindow = window.open("", "MsgWindow", "_blank");
						setTimeout(function() {
							myWindow.document.write(a);
						}, 3000);
						myWindow.document.title = 'TaxInvoice';
						setTimeout(function() {
							myWindow.print()
						}, 5000);
						this.btnDisable = false
					} else {
						this.$alertify.error(this.$t('common.invoiceURLError'));
						this.btnDisable = false;
					}
					this.isLoading = false
				}).catch((error) => {
					this.btnDisable = false;
					this.errorReport(error);
				});
		},


		printInvoice() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "getboxclient",
					data: ({
						warehouseid: userdetail.warehouseid,
						boxid: this.boxId,
					}),
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((clientdata) => {
					this.client = clientdata.data.data[0].data.clientid;
					if (clientdata.data.data[0].ErrorCode == -1) {
						this.productCheckIcon = '';
						this.$alertify.error(clientdata.data.data[0].msg);
					} else if (clientdata.data.data[0].ErrorCode == 0) {
						var clientid = clientdata.data.data[0].data[0].clientid;
						this.input = ({
							clientid: clientid,
							boxid: this.boxId,
						});
						this.isLoading = true
						axios({
								method: "post",
								url: apiUrl.api_url + "getPrintUrl",
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								},
							})
							.then((response) => {
								if (response.data.ErrorCode == 0) {
									if (response.data.data.invoice_document_external_url) {
										window.open(response.data.data.invoice_document_external_url, "_blank");
									} else {
										this.$alertify.error(this.$t('common.invoiceURLError'));
									}
								} else {
									this.$alertify.error(result.data.msg);
								}
								this.isLoading = false
							})
							.catch((error) => {
								this.errorReport(error);
							});
					}
					this.isLoading = false
				}).catch((error) => {
					this.errorReport(error);
				});
			return false
		},


		getweight: function() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			axios({
					method: "get",
					url: apiUrl.local_printer_api_url + "getWeight",
					data: ({}),
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((weightResponse) => {
					if (weightResponse.status == 200 && weightResponse.data.weight) {
						this.boxweight = parseFloat(weightResponse.data.weight);
					} else {
						this.$alertify.error(this.$t('common.weighingMachineError'));
						this.boxweight = 0;
					}
				})
				.catch((error) => {
					this.boxweight = 0;
					this.errorReport(error.response);
				});
		},

		carrierChange(obj) {
			if (Number(obj) == 1) {
				this.validreset()
			}
			this.courierName = ''
			this.awbNo = ''
			this.clientidForPrint = ''
			this.orderidForPrint = ''
			this.shippingcompanyForPrint = ''
			this.warehouseidForPrint = ''
			this.awbnoForPrint = ''
			this.boxId = ''
			this.packingtypebin = ''
			this.packingtypetote = ''
			this.isfound = false
			this.isnotfound = false
			this.orderId = ''
			this.boxId = ''
			this.isLoading = true;
			this.$nextTick(() => {
				if (this.productId) {
					document.getElementById('productId').disabled = false
				}
			})
			this.isLoading = false;
			this.productId = ''
			this.isfoundproductId = false
			this.isnotfoundproductId = false
			this.boxMapped = false
			this.productsPendingData = []
			this.isfoundDataPendingProduct = false
			this.uniqueIdScanProduct = ''
			this.rejectCheck = false
			this.isOtherReason = false
			this.checkedNames = []
			this.otherreason = ''
			this.productDetails = []
			this.showOrder = false
			this.showBoxId = false
			this.showPackingComplete = false
			this.shipmentFound = false
			this.allocationId = ""
			this.minisocheck = false
			this.clientName = ""
			this.totalquantity = 0
			this.cancel = 0
			this.canceldetails = []
			this.shipmentPrintNotAvailable = false
			this.shipmentPrintNotAvailableMSG = ''
			this.clientidForPrint = ''
			this.warehouseidForPrint = ''
			this.awbnoForPrint = ''
			this.totalsku = 0
			this.qcacceptqty = 0
			this.qcrejectqty = 0
			this.boxdetails = []
			this.orderDetails = {}
			this.boxl = ''
			this.boxb = ''
			this.boxh = ''
			this.seller = ''
			this.boxStatus = ''
			this.orderStatus = ''
			this.salesChannel = []
			this.shipmentStatus = ''
			this.couriername = ''
			this.showboxdetails = false
			this.showOrderDetails = false
			this.productCheckIcon = ''
			this.boxweight = 0
			this.client = ""
			this.showBox = false
			this.boxIdMapped = false
			this.$validator.reset()
		},

		async scanboxid() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.productCheckIcon = this.loadingText;
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			//start
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "getboxclient",
					data: ({
						warehouseid: userdetail.warehouseid,
						boxid: this.boxId,
					}),
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((clientdata) => {
					if (clientdata.data.data[0].ErrorCode == -1) {
						this.productCheckIcon = '';
						this.showPackingComplete = true
						this.$alertify.error(clientdata.data.data[0].msg);
					} else if (clientdata.data.data[0].ErrorCode == 0) {
						var clientid = clientdata.data.data[0].data[0].clientid;
						this.isLoading = true
						axios({
								method: "post",
								url: apiUrl.api_url + "getboxshipingstatus",
								data: ({
									clientid: clientid,
									warehouseid: userdetail.warehouseid,
									boxid: this.boxId,
								}),
								headers: {
									'Authorization': 'Bearer ' + myStr,
								}
							})
							.then((boxResponse) => {
								if (boxResponse.data.data[0].ErrorCode == -1) {
									this.productCheckIcon = '';
									this.$alertify.error(boxResponse.data.data[0].msg)
									this.showPackingComplete = true
								} else if (boxResponse.data.data[0].ErrorCode == 0) {
									if (this.type == 'tote') {
										var totebinid = this.packingtypetote
									} else if (this.type == 'bin') {
										var totebinid = this.packingtypebin
									}
									this.isLoading = true
									axios({
											method: 'POST',
											'url': apiUrl.api_url + 'finalToteBinPacking',
											'data': ({
												"warehouseid": userdetail.warehouseid,
												"clientid": this.clientid,
												"totebinid": totebinid,
												"carriertype": this.type,
												"orderid": this.orderId,
												"useremail": userdetail.email,
											}),
											headers: {
												'Authorization': 'Bearer ' + myStr
											}
										})
										.then(result => {
											if (result.data.data.ErrorCode == 0) {
												if (boxResponse.data.data[0].data.shipmentstatus == 'ready') {
													this.productCheckIcon = '';
													this.$alertify.error(this.$t('common.boxAlreadyPickedErr'));
												} else if (boxResponse.data.data[0].data.shipmentstatus == 'dispached') {
													this.productCheckIcon = '';
													this.$alertify.error(this.$t('common.boxDispatchedErr'));
												} else if (boxResponse.data.data[0].data.shipmentstatus == 'received') {
													this.productCheckIcon = '';
													this.$alertify.error(this.$t('common.boxDeliveredErr'));
												} else if (boxResponse.data.data[0].data.shipmentstatus == 'rto') {
													this.productCheckIcon = '';
													this.$alertify.error(this.$t('common.shipmentMarkErr'));
												} else if (boxResponse.data.data[0].data.shipmentstatus == 'packed' || boxResponse.data.data[0].data.shipmentstatus == null || boxResponse.data.data[0].data.shipmentstatus == 'failed') {
													// input details
													this.input = ({
														clientid: clientid,
														warehouseid: userdetail.warehouseid,
														boxid: this.boxId,
														useremail: userdetail.email,
														userid: userdetail.userid,
														boxweight: '' + this.boxweight,
														awbno: this.awbNo.trim(),
														couriername: this.courierName.trim(),
														boxl: this.boxl,
														boxb: this.boxb,
														boxh: this.boxh,
													});
													if (boxResponse.data.data[0].data.boxstatus == 'in_packing') {
														this.isLoading = false
														axios({
																method: "post",
																url: apiUrl.api_url + "boxpacking",
																data: this.input,
																headers: {
																	'Authorization': 'Bearer ' + myStr
																}
															})
															.then((response) => {
																if (response.data.data[0].ErrorCode == -1) {
																	this.productCheckIcon = '';
																	this.showPackingComplete = true
																	this.$alertify.error(response.data.data[0].msg)
																} else if (response.data.data[0].ErrorCode == 0) {
																	if (response.data.data[0].status == true) {
																		this.input = ({
																			clientid: clientid,
																			warehouseid: userdetail.warehouseid,
																			boxid: this.boxId,
																			useremail: userdetail.email,
																			userid: userdetail.userid,
																			boxweight: '' + this.boxweight
																		});
																		this.isLoading = true
																		axios({
																				method: "post",
																				url: apiUrl.api_url + "readytoship",
																				data: this.input,
																				headers: {
																					'Authorization': 'Bearer ' + myStr
																				}
																			})
																			.then((Shipresponse) => {
																				this.isLoading = false
																				this.resetFunction()
																				if (Shipresponse.data.data[0].ErrorCode == -1) {
																					this.productCheckIcon = '';
																					this.showPackingComplete = true;
																					this.$alertify.error(Shipresponse.data.data[0].msg)
																				} else if (Shipresponse.data.data[0].ErrorCode == 0) {
																					if (clientid == 1001 && clientid == 1002 && clientid == 1003) {
																						var invoice_array = [];
																						if (Shipresponse.data.data[0].data.printData.invoiceData) {
																							invoice_array.push(Shipresponse.data.data[0].data.printData.invoiceData);
																						}
																						if (Shipresponse.data.data[0].data.printData.custinvoice) {
																							invoice_array.push(Shipresponse.data.data[0].data.printData.custinvoice);
																						}
																						this.printInvCod(Shipresponse, invoice_array);
																					} else {
																						if (Shipresponse.data.data[0].data.awbno && Shipresponse.data.data[0].data.awbno != '') {
																							this.awbnoForPrint = Shipresponse.data.data[0].data.awbno
																						}
																						this.getPrintInvoiceEnableOrDisable(clientid);
																					}
																					this.productCheckIcon = '';
																					this.$alertify.success(Shipresponse.data.data[0].msg);
																				}
																			})
																			.catch((error) => {
																				document.getElementById('submitbtn').removeAttribute('disabled');
																				this.errorReport(error);
																			});
																	}
																}
																this.boxId = '';
																this.isLoading = false

															})
															.catch((error) => {
																document.getElementById('submitbtn').removeAttribute('disabled');
																this.errorReport(error);
															});
													} else if (boxResponse.data.data[0].data.boxstatus == 'in_shipping') // ready to ship
													{
														this.input = ({
															clientid: clientid,
															warehouseid: userdetail.warehouseid,
															boxid: this.boxId,
															useremail: userdetail.email,
															userid: userdetail.userid,
															boxweight: '' + this.boxweight
														});
														this.isLoading = true
														axios({
																method: "post",
																url: apiUrl.api_url + "readytoship",
																data: this.input,
																headers: {
																	'Authorization': 'Bearer ' + myStr
																}
															})
															.then((Shipresponse) => {
																this.isLoading = false
																if (Shipresponse.data.data[0].ErrorCode == -1) {
																	this.productCheckIcon = '';
																	this.showPackingComplete = true
																	this.$alertify.error(Shipresponse.data.data[0].msg)
																} else if (Shipresponse.data.data[0].ErrorCode == 0) {
																	if (clientid == 1001 && clientid == 1002 && clientid == 1003) {
																		var invoice_array = [];
																		if (Shipresponse.data.data[0].data.printData.invoiceData) {
																			invoice_array.push(Shipresponse.data.data[0].data.printData.invoiceData);
																		}
																		if (Shipresponse.data.data[0].data.printData.custinvoice) {
																			invoice_array.push(Shipresponse.data.data[0].data.printData.custinvoice);
																		}
																		this.printInvCod(Shipresponse, invoice_array);
																	} else {
																		if (Shipresponse.data.data[0].data.awbno && Shipresponse.data.data[0].data.awbno != '') {
																			this.awbnoForPrint = Shipresponse.data.data[0].data.awbno
																		}
																		this.getPrintInvoiceEnableOrDisable(clientid);
																	}
																	this.shipmentPrintNotAvailable = false;
																	this.shipmentPrintNotAvailableMSG = '';
																	this.productCheckIcon = '';
																	this.$alertify.success(Shipresponse.data.data[0].msg);
																}
															})
															.catch((error) => {
																document.getElementById('submitbtn').removeAttribute('disabled');
																this.errorReport(error);
															});
													} else {
														this.productCheckIcon = '';
														this.$alertify.error(this.$t('common.boxDeliveredErr'));
													}
												} else {
													this.productCheckIcon = '';
													this.$alertify.error(this.$t('common.boxDeliveredErr'));
												}
											} else {
												this.$alertify.error(result.data.data.msg);
												this.showPackingComplete = true
												return false;
											}
											this.isLoading = true
										}, error => {
											console.error(error)
										})
								}
								this.isLoading = false
							})
							.catch((error) => {
								document.getElementById('submitbtn').removeAttribute('disabled');
								this.errorReport(error);
							});
					}
					this.isLoading = false
				})
				.catch((error) => {
					document.getElementById('submitbtn').removeAttribute('disabled');
					this.errorReport(error);
				});
			//end
		},
		async resetFunction() {
			this.boxId = ''
			this.isLoading = true
			this.courierName = ''
			this.boxl = ''
			this.boxb = ''
			this.boxh = ''
			this.isfoundDataPendingProduct = false
			let result = await Promise.all([
				this.Showtable()
			]);
			this.$nextTick(() => {
				if (this.type == 'bin') {
					if (this.productsPendingData.length) {
						this.packingtypetote = ''
						if (this.productId) {
							document.getElementById('productId').disabled = false;
						}
						this.productId = ''
						this.isfoundproductId = false
						this.isnotfoundproductId = false
						this.showQCButton = false
						if (this.boxId) {
							document.getElementById('boxId').disabled = false;
						}
						this.boxId = ''
						this.boxMapped = false
						this.rejectCheck = false
						this.isOtherReason = false
						this.showPackingComplete = false
					} else {
						this.packingtypebin = ''
						this.packingtypetote = ''
						this.isfound = false
						this.isnotfound = false
						if (this.productId) {
							document.getElementById('productId').disabled = false;
						}
						this.productId = ''
						this.isfoundproductId = false
						this.isnotfoundproductId = false
						this.showQCButton = false
						if (this.boxId) {
							document.getElementById('boxId').disabled = false;
						}
						this.boxMapped = false
						this.rejectCheck = false
						this.isOtherReason = false
						this.showPackingComplete = false
						this.boxId = ''
					}
					this.boxIdMapped = false
				} else if (this.type == 'tote') {
					this.isfound = false
					this.isnotfound = false
					this.packingtypetote = ''
					if (this.productsPendingData.length) {
						this.packingtypebin = ''
						if (this.productId) {
							document.getElementById('productId').disabled = false;
						}
						this.productId = ''
						this.isfoundproductId = false
						this.isnotfoundproductId = false
						this.showQCButton = false
						if (this.boxId) {
							document.getElementById('boxId').disabled = true;
						}
						this.boxMapped = false
						this.rejectCheck = false
						this.isOtherReason = false
						this.showPackingComplete = false
					} else {
						this.packingtypebin = ''
						this.packingtypetote = ''
						this.isfound = false
						this.isnotfound = false
						if (this.productId) {
							document.getElementById('productId').disabled = false;
						}
						this.productId = ''
						this.isfoundproductId = false
						this.isnotfoundproductId = false
						this.showQCButton = false
						if (this.boxId) {
							document.getElementById('boxId').disabled = true;
						}
						this.boxMapped = false
						this.rejectCheck = false
						this.isOtherReason = false
						this.showPackingComplete = false
						this.boxId = ''
					}
					this.boxIdMapped = false
				}
				this.showBox = false
				this.boxIdMapped = false
				this.$validator.reset()
			})
			this.isLoading = false;
		},

		scanReset() {
			this.shipmentPrintNotAvailable = false
			this.printLabelEnable = false
			this.printInvoiceEnable = false
			this.showboxdetails = false
			this.isLoading = true;
			this.$nextTick(() => {
				if (this.boxId && !this.boxIdMapped) {
					document.getElementById('boxId').disabled = false
				}
			})
			this.isLoading = false;
		},
		errorReport: function(error) {
			if (error.response) {
				// The request was made and the server responded with a status code that falls out of the range of 2xx
				this.$alertify.error(error.response.data.message);
			} else if (error.request) {
				// The request was made but no response was received `error.request` is an instance of XMLHttpRequest in the browser and an instance of
				// http.ClientRequest in node.js
				this.$alertify.error(this.$t('common.requestTimeoutErr'));
			} else {
				// Something happened in setting up the request that triggered an Error
				this.$alertify.error(error.message);
			}
		},

		getPrintInvoiceEnableOrDisable(clientid) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var input = ({
				localclientid: clientid,
				warehouseidlocal: this.warehouseid
			});
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "getconfig",
					'data': input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((response) => {
					this.isLoading = false
					if (response.status == 200) {
						var result = response.data
						var isprintEnable = false;
						for (var i = 0; i < result.length; i++) {
							if (result[i].type == "print_invoice_ONOFF") {
								if (result[i].flag == "no") {
									this.printInvoiceEnable = false
								} else {
									this.printInvoiceEnable = true
								}
							}
							if (result[i].type == "print_label_ONOFF") {
								if (result[i].flag == "no") {
									this.printLabelEnable = false
								} else {
									this.printLabelEnable = true
								}
							}
						}
					} else {
						this.$alertify.error(this.$t('common.configDetailsNotfoundErr'));
					}
				}).catch((error) => {
					this.errorReport(error);
				});
		},

		printInvCod: function(Shipresponse) {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.isLoading = true
			axios({
					method: "POST",
					'url': apiUrl.local_printer_api_url + 'printer/printcod',
					data: {
						codData: Shipresponse.data.data[0].data.printData.codData,
						invoices: invoice_array,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(response => {
					if (response.data.code == 200) {
						this.$alertify.success(this.$t('consolidation.codStickerPrinteddSuccess'));
					} else {
						this.$alertify.error(this.$t('common.failedToPrintErr'));
					}
					this.isLoading = false
				})
				.catch((error) => {
					document.getElementById('submitbtn').removeAttribute('disabled');
					this.errorReport(error);
				});
		},


		checkAwb() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.awbnoForPrint = ''
			this.clientidForPrint = ''
			this.warehouseidForPrint = ''
			this.orderidForPrint = ''
			this.shippingcompanyForPrint = ''
			this.input = ({
				shippingcompany: this.courierName.trim(),
				awbno: this.awbNo.trim(),
				orderid: this.orderId,
				clientid: Number(this.clientid)
			});
			this.isLoading = true
			this.showPackingComplete = false
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'checkAWBPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.isLoading = false
					if (result.data.data[0].ErrorCode == 0) {
						this.awbnoForPrint = this.awbNo.trim(),
							this.orderidForPrint = this.orderId
						this.shippingcompanyForPrint = this.courierName.trim()
						this.clientidForPrint = Number(this.clientid),
							this.warehouseidForPrint = Number(this.warehouseid),
							this.scanboxid();
					} else {
						this.$alertify.error(result.data.data[0].msg);
						this.showPackingComplete = true
						return false;
					}
				}, error => {
					console.error(error)
				})
		},

		getBoxDetails: function(check) {
			this.courierName = ''
			this.awbNo = ''
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			this.shipmentPrintNotAvailable = false;
			this.shipmentPrintNotAvailableMSG = '';
			this.totalquantity = 0;
			this.cancel = 0;
			this.qcacceptqty = 0;
			this.isLoading = true
			axios({
					method: "post",
					url: apiUrl.api_url + "getboxclient",
					data: ({
						warehouseid: this.warehouseid,
						boxid: this.boxId,
					}),
					headers: {
						'Authorization': 'Bearer ' + myStr,
					},
				})
				.then((clientdata) => {
					this.isLoading = false
					if (clientdata.data.data[0].ErrorCode == -1) {
						this.$alertify.error(clientdata.data.data[0].msg);
						return false;
					} else if (clientdata.data.data[0].ErrorCode == 0) {
						this.clientName = clientdata.data.data[0].data[0].clientname;
						var clientid = clientdata.data.data[0].data[0].clientid;
						this.input = ({
							clientid: clientid,
							boxid: this.boxId,
						});
						this.isLoading = true;
						axios({
								method: "post",
								url: apiUrl.api_url + "getpackingdetails",
								'data': this.input,
								headers: {
									'Authorization': 'Bearer ' + myStr,
								},
							})
							.then((response) => {
								this.shipmentFound = false;
								var result = response.data.data;
								var num = [];
								var numcancel = [];
								let product_skus = [];
								this.isLoading = false;
								this.cancel = 0;
								this.canceldetails = [];
								if (result[0].ErrorCode == 0) {
									this.isLoading = false;
									if (clientid == 1005) {
										this.minisocheck = true;
									}
									//start of Logic for if shipping_id found
									let shipmentid = response.data.data[0].data.boxdata[0].shipment_id != '' || response.data.data[0].data.boxdata[0].shipment_id != null ? response.data.data[0].data.boxdata[0].shipment_id : '';
									if ((shipmentid == null || shipmentid == '') && response.data.data[0].data.boxdata[0].boxstatus != 'in_shipping') {
										this.shipmentPrintNotAvailable = false;
										this.shipmentPrintNotAvailableMSG = 'Order has no shipment. Get invoice and shipping label from client system.';
									} else if (shipmentid == null || shipmentid == '') {
										this.shipmentPrintNotAvailable = false;
										if (result[0].data.boxdata[0].awbno != '' && result[0].data.boxdata[0].awbno != null && response.data.data[0].data.boxdata[0].boxstatus == 'in_shipping') {
											this.getPrintInvoiceEnableOrDisable(clientid);
											this.clientidForPrint = clientid
											this.orderidForPrint = result[0].data.boxdata[0].order_id
											this.shippingcompanyForPrint = result[0].data.boxdata[0].shippingcompany
											this.warehouseidForPrint = userdetail.warehouseid
											this.awbnoForPrint = result[0].data.boxdata[0].awbno
										}
									} else {
										this.shipmentPrintNotAvailable = true;
									}
									//end of Logic for if shipping_id found
									for (var i = 0; i < response.data.data[0].data.boxdata.length; i++) {
										if (response.data.data[0].data.boxdata[i].cancelqty > 0) {
											numcancel.push(response.data.data[0].data.boxdata[i].cancelqty);
											this.cancel += parseInt(Number(response.data.data[0].data.boxdata[i].cancelqty));
											this.canceldetails.push(
												response.data.data[0].data.boxdata[i],
											);
										}
										num.push(response.data.data[0].data.boxdata[i].pickqty);
										this.totalquantity += parseInt(Number(num[i]));
										if (product_skus.indexOf(response.data.data[0].data.boxdata[i].productid) == -1) {
											product_skus.push(response.data.data[0].data.boxdata[i].productid);
										}
									}
									if (Number(this.cancel) == Number(this.totalquantity)) {
										this.$alertify.error(this.$t('common.productCancelledErr'));
										return false;
									}
									this.totalsku = product_skus.length;
									this.qcacceptqty = response.data.data[0].data.qcData.allQC.totalQCAcceptQty;
									this.qcrejectqty = response.data.data[0].data.qcData.allQC.totalQCRejectQty;
									this.boxdetails = result[0].data;
									//start of Logic for if shipping_id found
									let awb_no = response.data.data[0].data.shipmentData != undefined ? response.data.data[0].data.shipmentData.awb_no : ''
									//end of Logic for if shipping_id found
									this.orderDetails = {}
									for (var i = 0; i < result[0].data.boxdata.length; i++) {
										//start of Logic for if shipping_id found
										this.awbNo = result[0].data.boxdata[i].awbnumber != null && result[0].data.boxdata[i].awbnumber != '' ? result[0].data.boxdata[i].awbnumber : awb_no;
										//end of Logic for if shipping_id found
										if (clientid == 1005) {
											this.boxl = result[0].data.boxdata[i].length;
											this.boxb = result[0].data.boxdata[i].width;
											this.boxh = result[0].data.boxdata[i].height
										}
										this.seller = result[0].data.boxdata[i].saleschannel;
										this.boxStatus = result[0].data.boxdata[i].boxstatus;
										this.orderStatus = result[0].data.boxdata[i].status;

										if (result[0].data.boxdata[i].shipment_id == null) {
											result[0].data.boxdata[i].shipment_id = ""
										}
										this.orderDetails = {
											"orderid": result[0].data.boxdata[i].order_id,
											"saleschannel": result[0].data.boxdata[i].saleschannel,
											"shipmentid": result[0].data.boxdata[i].shipment_id,
											"boxproductqty": this.totalquantity - this.cancel,
										}
										if (result[0].data.boxdata[i].awbno && result[0].data.boxdata[i].awbno != '') {
											this.orderDetails.awbno = result[0].data.boxdata[i].awbno
										}
										if (result[0].data.boxdata[i].shippingcompany && result[0].data.boxdata[i].shippingcompany != '') {
											this.orderDetails.shippingcompany = result[0].data.boxdata[i].shippingcompany
										}
										if (result[0].data.boxdata[i].totalorderqty && result[0].data.boxdata[i].totalorderqty != '') {
											if (result[0].data.boxdata[i].totalorderqty == null) {
												this.orderDetails.Orderqty = ''
											} else {
												this.orderDetails.Orderqty = result[0].data.boxdata[i].totalorderqty
											}
										}
									}
									if ((this.totalquantity - this.cancel) === this.qcacceptqty) {
										this.showPackingComplete = true
										this.showQCButton = false
										this.productId = ""
										this.isLoading = true
										this.$nextTick(() => {
											document.getElementById('boxId').disabled = true;
										})
										this.isLoading = false
									} else {
										this.showPackingComplete = false
									}
									if (this.boxStatus == 'in_packing' || this.boxStatus == null || this.boxStatus == 'failed') {
										this.showboxdetails = true
									} else {
										this.showboxdetails = false
										this.$alertify.error(this.$t('consolidation.boxStatusErr') + this.boxStatus + this.$t('consolidation.canNotDoneErr'));
										if (this.orderStatus == "dispatched" || this.orderStatus == "packed" || this.orderStatus == "rto" || this.orderStatus == "cancelled") {
											this.showOrderDetails = true
										}
									}
									this.salesChannel = []
									if (shipmentid == null || shipmentid == '') {
										this.salesChannel.push({
											'courierid': 'E-Kart',
											'couriername': 'E-Kart'
										}, {
											'courierid': 'ATS',
											'couriername': 'ATS'
										}, {
											'courierid': 'Myntra',
											'couriername': 'Myntra'
										}, {
											'courierid': 'Xpressbees',
											'couriername': 'Xpressbees'
										}, {
											'courierid': 'Bluedart',
											'couriername': 'Bluedart'
										}, {
											'courierid': 'E-Com',
											'couriername': 'E-Com'
										}, {
											'courierid': 'Gati',
											'couriername': 'Gati'
										}, {
											'courierid': 'Delhivery',
											'couriername': 'Delhivery'
										}, {
											'courierid': 'Amara',
											'couriername': 'Amara'
										}, {
											'courierid': 'Shadowfax P2P',
											'couriername': 'Shadowfax P2P'
										}, {
											'courierid': 'Shadofax Express',
											'couriername': 'Shadofax Express'
										}, {
											'courierid': 'Others',
											'couriername': 'Others'
										}, )
									} else {
										this.shipmentFound = true;
										this.showPackingComplete = true;
										this.shipmentStatus = response.data.data[0].data.shipmentData.status_name;
										let channel_name = response.data.data[0].data.shipmentData != undefined ? response.data.data[0].data.shipmentData.channel_name : ''
										let courier_name = response.data.data[0].data.shipmentData != undefined ? response.data.data[0].data.shipmentData.courier_details.courier_name : '';
										this.seller = channel_name;
										this.saleschannel.push({
											'courierid': courier_name,
											'couriername': courier_name
										});
										this.couriername = this.saleschannel[0].couriername.trim();
									}
								} else {
									this.isLoading = false;
									this.shipmentPrintNotAvailable = false;
									this.shipmentPrintNotAvailableMSG = '';
									this.awbNo = '';
									this.showboxdetails = false;
									this.$alertify.error(response.data.data[0].msg);
									this.orderDetails = {}
									if (result[0].data.length > 0) {
										for (var i = 0; i < result[0].data.length; i++) {
											this.boxStatus = result[0].data[i].boxstatus;
											this.orderStatus = result[0].data[i].status;
											if (result[0].data[i].shipment_id == null) {
												result[0].data[i].shipment_id = ""
											}
											this.orderDetails = {
												"orderid": result[0].data[i].order_id,
												"saleschannel": result[0].data[i].saleschannel,
												"shipmentid": result[0].data[i].shipment_id,
												"boxproductqty": this.totalquantity - this.cancel,
											}
											if (result[0].data.awbno && result[0].data.awbno != '') {
												this.orderDetails.awbno = result[0].data.awbno
											}
											if (result[0].data.shippingcompany && result[0].data.shippingcompany != '') {
												this.orderDetails.shippingcompany = result[0].data.shippingcompany
											}
											if (result[0].data.totalorderqty && result[0].data.totalorderqty != '') {
												if (result[0].data.totalorderqty == null) {
													this.orderDetails.Orderqty = ''
												} else {
													this.orderDetails.Orderqty = result[0].data.totalorderqty
												}
											}
										}
										if (this.orderStatus == 'cancelled') { //newchange
											this.carrierChange(1) //newchange
											return false; //newchange
										} //newchange
										if (this.orderStatus == "dispatched" || this.orderStatus == "packed" || this.orderStatus == "rto" || this.orderStatus == "cancelled") {
											this.showOrderDetails = true
										}
									}
								}
							})
							.catch((error) => {
								this.isLoading = false;
								this.errorReport(error);
							});
					}
					this.isLoading = false;
				}).catch((error) => {
					this.errorReport(error);
				});
			return false
		},

		ProductDetails(value) {
			if (value == 'reject') {
				this.rejectCheck = true
				if (!this.checkedNames.length) {
					return false
				}
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (this.checkedNames.indexOf('Other') > -1) {
				var index = this.checkedNames.indexOf('Other')
				if (this.otherreason == '') {
					this.isCheckboxError = '1'
					this.Checkboxerrors = 'Enter reason'
					return false;
				} else {
					this.isCheckboxError = ''
					this.Checkboxerrors = ''
					this.checkedNames.push(this.otherreason)
				}
			}
			this.rejectreasons = this.checkedNames.map(function(val) {
				if (val != 'Other' && val.trim() != '')
					return val
				else
					return null
			}).filter(function(value) {
				return value != null;
			})
			if (value == 'reject') {
				this.checkedNames = this.rejectreasons
			}
			var productidNew = ""
			this.productsPendingData.forEach((result) => {
				if ((String(result.productid) == String(this.productId)) || (String(result.eancode) == String(this.productId))) {
					productidNew = ""
					productidNew = Number(result.productid)
				}
			})
			this.isLoading = true
			this.input = ({
				"clientid": Number(this.clientid),
				"warehouseid": Number(this.warehouseid),
				"orderid": this.orderId,
				"boxid": Number(this.boxId),
				"productid": productidNew,
				"qcstatus": value,
				"rejectreasons": this.checkedNames,
				"qty": 1,
				"useremail": this.useremail
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'packingProductQC',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data[0].ErrorCode == 0) {
						this.productQC(value)
					}
					this.isLoading = false
				}, error => {
					console.error(error);
				});
		},
		checkOtherReason() {
			if (this.checkedNames.indexOf('Other') > -1) {
				this.isOtherReason = true
			} else {
				this.isOtherReason = false
				this.otherreason = ''
			}
		},
		clearerror() {
			if (this.otherreason == '') {
				this.isCheckboxError = '1'
				this.Checkboxerrors = 'Enter reason'
			} else {
				this.isCheckboxError = ''
				this.Checkboxerrors = ''
			}
		},
		productQCReject(qcStatus) {
			if (qcStatus == 'reject') {
				this.rejectCheck = true
			}
		},

		productQC(qcstatus) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			if (this.type == 'tote') {
				var totebinid = this.packingtypetote
			} else if (this.type == 'bin') {
				var totebinid = this.packingtypebin
			}
			this.input = ({
				warehouseid: this.warehouseid,
				clientid: this.clientid,
				totebinid: totebinid,
				carriertype: this.type,
				orderid: this.orderId,
				productid: this.productId,
				qcstatus: qcstatus,
				uniqueid: this.uniqueIdScanProduct
			});
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'scanToteBinProductForPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.showQCButton = false
						this.rejectCheck = false
						this.isOtherReason = false
						this.$alertify.success(result.data.data.msg);
						if (this.type == 'bin' || this.shipmentFound) {
							this.isLoading = true
							this.$nextTick(() => {
								document.getElementById('productId').disabled = true;
							})
							this.isLoading = false
							this.Showtable()
							this.getBoxDetails(1)
						} else if (this.type == 'tote') {
							this.productId = ""
							this.Showtable()
							this.getBoxDetails(1)
						}
					} else {
						this.$alertify.error(result.data.data.msg);
					}
					this.isLoading = false
				}, error => {
					console.error(error);
				});
		},
		validateProduct() {
			this.scanReset();
			if (!this.productId) {
				this.$alertify.error(this.$t('consolidation.productIdRequiredErr'));
				return false;
			}
			this.orderId = ""
			this.boxId = ""
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			if (this.type == 'tote') {
				var totebinid = this.packingtypetote
			} else if (this.type == 'bin') {
				var totebinid = this.packingtypebin
			}
			this.input = ({
				warehouseid: this.warehouseid,
				clientid: this.clientid,
				totebinid: totebinid,
				carriertype: this.type,
				productid: this.productId,
			});
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'validateToteBinProductForPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						if (Number(result.data.data.data.data.consoscan) == 1) {
							this.showQCButton = false
							this.$alertify.error(this.$t('consolidation.productScannedErr'));
							this.productId = "" //newchange
							this.isLoading = false //newchange
							//	return false; //newchange
						} else {
							this.showQCButton = true
						}
						this.isfoundproductId = true
						this.isnotfoundproductId = false
						this.uniqueIdScanProduct = result.data.data.data.data.id
						this.orderId = result.data.data.data.data.orderid
						this.showBox = true
						this.productDetails = result.data.data.data.productdetails
						this.allocationId = result.data.data.data.data.orderitemrackid
						if (this.type == 'tote') {
							if (result.data.data.data.shipmentDetails && result.data.data.data.shipmentDetails.boxid) {
								this.boxId = result.data.data.data.shipmentDetails.boxid
								if (this.boxId) {
									this.isLoading = true;
									this.$nextTick(() => {
										document.getElementById('boxId').disabled = true;
									});
									this.isLoading = false;
									this.boxMapped = true;
									this.boxIdMapped = true;
									this.getBoxDetails(1);
								}
							} else {
								if (this.boxId) {
									this.isLoading = true;
									this.$nextTick(() => {
										document.getElementById('boxId').disabled = false;
									})
									this.isLoading = false;
								}
								this.boxIdMapped = false
							}
							if (result.data.data.data.data.shipmentid) {
								this.shipmentID = result.data.data.data.data.shipmentid
							} else {
								this.shipmentID = ""
							}
						} else if (this.type == 'bin') {
							if (result.data.data.data.shipmentDetails && result.data.data.data.shipmentDetails.boxid) {
								this.boxId = result.data.data.data.shipmentDetails.boxid
								if (this.boxId) {
									this.isLoading = true;
									this.$nextTick(() => {
										document.getElementById('boxId').disabled = true;
									});
									this.isLoading = false;
									this.boxMapped = true;
									this.boxIdMapped = true;
									this.getBoxDetails(1);
								}
							} else {
								if (this.boxId) {
									this.isLoading = true;
									this.$nextTick(() => {
										document.getElementById('boxId').disabled = false;
									})
									this.isLoading = false;
								}
								this.boxIdMapped = false
							}
							if (result.data.data.data.shipmentDetails && result.data.data.data.shipmentDetails.shipment_id) {
								this.shipmentID = result.data.data.data.shipmentDetails.shipment_id
							} else {
								this.shipmentID = ""
							}
						}
						this.showOrder = true
					} else {
						this.productId = ''
						this.$alertify.error(this.$t('consolidation.invalidProductErr'));
						this.showBox = false
						this.isfoundproductId = false
						this.isnotfoundproductId = true
						this.allocationId = ""
						this.orderId = ""
						this.productDetails = []
						this.showOrder = false
						this.showQCButton = false
						this.uniqueIdScanProduct = ''
					}
					this.isLoading = false
				}, error => {
					console.error(error);
				});
		},
		closeTable() {
			this.isfoundDataPendingProduct = false
		},
		assignBoxIdToOrder() {
			if (!this.boxIdMapped && this.boxId) {
				this.courierName = ''
				this.awbNo = ''
				if (isNaN(this.boxId)) {
					this.boxId = ''
					this.$alertify.error(this.$t('consolidation.boxIdMustNumberErr'));
				}
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.pageno = 0;
				if (this.showSelectWarehouse == true) {
					this.warehouseid = this.warehousename
				}
				this.input = ({
					clientid: this.clientid,
					warehouseid: this.warehouseid,
					userid: this.userId,
					orderid: this.orderId,
					boxid: this.boxId,
					itemid: this.allocationId,
					shipmentid: this.shipmentID,
				});
				this.isLoading = true
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'validateBox',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						if (result.data.data.ErrorCode == 0) {
							if (result.data.data.msg == "Invalid box or box not available") {
								this.boxMapped = false;
								this.boxId = '';
								this.$alertify.error(result.data.data.msg);
							} else {
								axios({
										method: 'POST',
										'url': apiUrl.api_url + 'UpdateBoxIdOrderItemDetails',
										'data': {
											"clientid": this.clientid,
											"warehouseid": this.warehouseid,
											"orderid": this.orderId,
											"boxid": this.boxId,
											"allocationid": this.allocationId,
											"userid": this.userId,
											"shipmentid": this.shipmentID
										},
										headers: {
											'Authorization': 'Bearer ' + myStr,
										}
									})
									.then(result => {
										if (result.data.data.ErrorCode == 0) {
											this.isLoading = true;
											this.$nextTick(() => {
												document.getElementById('boxId').disabled = true;
											})
											this.isLoading = false;
											this.boxMapped = true;
											this.getBoxDetails(1)
											this.$alertify.success(result.data.data.msg);
										} else {
											this.boxMapped = false;
											this.boxId = '';
											this.$alertify.error(result.data.data.msg);
										}
									}, error => {
										console.error(error);
									});
							}
						} else {
							this.boxMapped = false;
							this.$alertify.error(result.data.data.msg);
						}
						this.isLoading = false
					}, error => {
						console.error(error);
					});
			}
		},

		Showtable(obj) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			if (this.type == 'tote') {
				var totebinid = this.packingtypetote
			} else if (this.type == 'bin') {
				var totebinid = this.packingtypebin
			}
			this.input = ({
				clientid: this.clientid,
				warehouseid: this.warehouseid,
				totebinid: totebinid,
				carriertype: this.type
			});
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getPendingProductsBinTote',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						if (Number(obj) == 1) {
							this.isfoundDataPendingProduct = true
						}
						this.productsPendingData = result.data.data.data
					} else {
						console.log(result.data.data.msg);
						this.productsPendingData = []
					}
					this.isLoading = false
				}, error => {
					console.error(error);
				});
		},

		validreset() {
			this.showOrder = false
			this.showboxdetails = false
			this.orderId = ''
			this.boxId = ''
			this.productsPendingData = []
			this.clientName = ''
			this.shipmentPrintNotAvailable = false
			this.printLabelEnable = false
			this.printInvoiceEnable = false
		},

		validateid() {
			this.validreset()
			this.showQCButton = false
			this.productId = ''
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			if (this.showSelectWarehouse == true) {
				this.warehouseid = this.warehousename
			}
			if (this.type == 'tote') {
				var totebinid = this.packingtypetote
			} else if (this.type == 'bin') {
				var totebinid = this.packingtypebin
			}
			if (!totebinid) {
				return false;
			}
			this.input = ({
				warehouseid: this.warehouseid,
				totebinid: totebinid,
				carriertype: this.type
			});
			this.isLoading = true
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'validateToteBinForPacking',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.clientid = result.data.data.data.clientid
						this.isfound = true;
						this.isnotfound = false;
						this.Showtable()
					} else {
						this.isfound = false;
						this.isnotfound = true;
						this.packingtypebin = '';
						this.packingtypetote = '';
						this.$alertify.error("Invalid " + this.type);
					}
					this.isLoading = false
				}, error => {
					console.error(error);
				});
		},


		getWarehouseList() {
			if (window.localStorage.getItem("warehouseList") !== null) {
				var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
				var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
				var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
				this.listWarehouseData = JSON.parse(plaintextwarehouse);
			} else {
				var userToken = window.localStorage.getItem('userToken')
				var myStr = userToken.replace(/"/g, '');
				this.input = ({
					clientid: this.clientid,
				});
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then(result => {
						this.listWarehouseData = result.data.data;
					}, error => {
						console.error(error)
					})
			}
		},

		clientSelected() {
			if (this.clientid != this.client) {
				if (this.clientid)
					this.getWarehouseList();
				if (this.user_type != 'warehouse_user') {
					this.listWarehouseData = []
					this.getWarehouseList();
					if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
						this.warehouse = this.warehouseid = '';
					} else {
						this.warehouse = ''
					}
				} else {
					if (this.warehouseid && this.clientid) {}
				}
				this.orderids = [];
			}
			this.totalRows = 0;
			this.listOrdersData = [];
			this.pageNo = this.totalPage = 0;
		},
		warehouseSelected() {
			this.warehouseid = this.warehouse;
			this.listOrdersData = [];
			this.pageNo = this.totalPage = 0;
			this.totalRows = 0;
			if (this.warehouseid) {
				if (this.clientid) {} else {}
			}
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/consopacking/consopacking.component.js